<div  *ngFor="let medAlertByCategory of alertsByCategory">
   <table>
        <thead>
        <th>
            {{medAlertByCategory.category}}
        </th>
        <th>
            Email
            <div>
                <img src="assets/img/icon-email.png">
            </div>
        </th>
        <th>
            SMS
            <div>
                <img src="assets/img/icon-sms.png">
            </div>
        </th>
        <th>
            Desktop
            <div>
                <img src="assets/img/icon-desktop.png">
            </div>
        </th>
        </thead>
        <tbody>
        <tr *ngFor="let alert of medAlertByCategory.alerts">
            <ng-template #popTemplate>
                <div>
                    <b>Supported in the following facilities: </b>
                    <br>
                    {{getTooltipText(alert)}}
                    <br>
                    <br>
                    Please contact your account manager to set up new rules.
                </div>
            </ng-template>
            <td>
                <span class="{{getSupportedFacilitiesCount(alert)===0 ? 'disabled-alert' : ''}}">
                    {{alert.Caption}}
                </span>
                <span *ngIf="hasUnsupportedFacilities(alert)" placement="right" [tooltip]="popTemplate">
                    <span class="{{getSupportedFacilitiesCount(alert)===0 ? 'disabled-alert' : ''}}">
                        <img src="assets/img/icon-warn.png"> {{getSupportedFacilitiesCount(alert)}}
                    </span>
                </span>
                <span class="{{getSupportedFacilitiesCount(alert)===0 ? 'disabled-alert' : ''}}">
                    <div class="description">
                        {{alert.UIDescription}}
                    </div>
                </span>
            </td>
            <td><label class="checkbox"><input type="checkbox" [disabled]="nurseRole || getSupportedFacilitiesCount(alert)===0" [(ngModel)]="alert.Email"><span></span></label></td>
            <td><label class="checkbox"><input type="checkbox" [disabled]="nurseRole || getSupportedFacilitiesCount(alert)===0" [(ngModel)]="alert.SMS" (change)="checkPhoneNumber($event)"><span></span></label></td>
            <td><label class="checkbox"><input type="checkbox" [disabled]="nurseRole || getSupportedFacilitiesCount(alert)===0 || true" [(ngModel)]="alert.Desktop"><span></span></label></td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="isLoading" style="width: 100%; height: 128px; background: transparent url('assets/img/loading.gif') no-repeat center center">&nbsp;</div>
</div>